import { contrastColorOn, createColor, hsla } from '../styles/colors'
import { ITheme } from '../context/AppContext'
import { ICompany } from '../common/models/Company'

// This function converts the string value of the culture value into the correct color variant
export const cultureValueColors = (
  theme: ITheme,
  color: string,
  company?: ICompany,
  hslArray?: number[]
): {
  textColor: string
  darkValueColor: string
  lightValueColor: string
  mediumValueColor: string | undefined
} => {
  const hslArr = company ? company.companyColors[color] : hslArray

  return {
    textColor: contrastColorOn(theme.colors[color] || color),
    darkValueColor: hslArr
      ? createColor(hslArr, hslArr[2] > 30 ? 25 : 15)
      : theme.colors.darkest,
    lightValueColor: hslArr ? createColor(hslArr, 92) : theme.colors.lightest,
    // An explicit hslArray means "build from this stored HSL, ignore the live
    // theme" (historical snapshots) — so it wins. Company mode keeps the
    // theme-derived alpha.
    mediumValueColor: hslArray
      ? createColor(hslArray, 60)
      : theme.colors[color]
      ? hsla(theme.colors[color], 0.5)
      : undefined,
  }
}
